/*
 * 活动
 * @Author: Lzyoung
 * @Date: 2019-03-15 11:02:16
 * @Last Modified by: Lzyoung
 * @Last Modified time: 2019-03-20 16:56:38
 */

import request from '../ajax';

// 获取调查问卷问题
export function getQuestions(surveyId) {
  return request.post({
    reqMethod: 'base.survey.getDetail',
    params: {
      surveyId
    }
  })
}

// 提交调查问卷答案
export function submitAnswers(params) {
  return request.post({
    reqMethod: 'base.survey.submit',
    params: params
  })
}

// 判断用户是否做过问卷
export function isUserDoneForSurvey(params) {
  return request.post({
    reqMethod: 'base.survey.isUserDoneForSurvey',
    params: params
  })
}

// 获取用户信息
export function getUserData(params) {
  return request.post({
    reqMethod: 'account.userdata.getUserData',
    params: params
  })
}

// 派券限制
export function receiveCouponForSurvey(params) {
  return request.post({
    reqMethod: 'eshop.goodsSend.receiveCouponForSurvey',
    params: params
  })
}
